import { BOOLEAN_OPTIONS } from "@/constant/GeneralOptions/boolean";
import { STATUS } from "@/constant/statusConstants";

const getPostInitialValues = (showData = null) => {
  const data = showData?.data;
  return {
    title: data?.title || "",
    sub_title: data?.sub_title || "",
    content: data?.content || "",
    status: data?.status || STATUS.INACTIVE,
    sport_id: data?.sport?.id || "",
    blog_category_id: data?.category?.id || "",
    banner_url: data?.banner_url || "",
    thumbnail_url: data?.thumbnail_url || "",
    auto_translate: data?.auto_translate ?? BOOLEAN_OPTIONS.NO,
  }
};

export default getPostInitialValues;
